import { AbstractControl, ValidatorFn } from '@angular/forms';

/**
 * https://github.com/platanus/rut-helpers
 */
export const validateRUT = (): ValidatorFn => (
  control: AbstractControl,
): { [key: string]: string } | null => {
  const errorMessage = {
    RUT_ERROR: 'Please provide a valid RUT',
  };
  const value: string = control.value || '';

  const rut: string = rutClean(value);
  let rutDigits = parseInt(rut.slice(0, -1), 10);
  let m = 0;
  let s = 1;

  while (rutDigits > 0) {
    s = (s + (rutDigits % 10) * (9 - (m++ % 6))) % 11;
    rutDigits = Math.floor(rutDigits / 10);
  }
  const checkDigit: string = s > 0 ? String(s - 1) : 'K';

  if (checkDigit !== rut.slice(-1)) {
    return errorMessage;
  }

  return null;
};

export function rutClean(value: string) {
  return typeof value === 'string'
    ? value.replace(/[^0-9kK]+/g, '').toUpperCase()
    : '';
}
